import { createSlice } from "@reduxjs/toolkit";
import { BodyWashProduct } from "../../Api/Api"; // Import API function

const bodyWashSlice = createSlice({
    name: "bodyWash",
    initialState: {
        products: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(BodyWashProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(BodyWashProduct.fulfilled, (state, action) => {
                //console.log("Data Received in Redux:", action.payload);
                state.products = action.payload; // Ensure this is an array
                state.loading = false;
            })
            .addCase(BodyWashProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default bodyWashSlice.reducer;
